"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elements = void 0;
const elementsAndIsotopes_js_1 = require("./elementsAndIsotopes.js");
exports.elements = elementsAndIsotopes_js_1.elementsAndIsotopes.map((element) => ({
    number: element.number,
    symbol: element.symbol,
    mass: element.mass,
    name: element.name,
    monoisotopicMass: element.monoisotopicMass,
}));
//# sourceMappingURL=elements.js.map